<template>
<v-layout row wrap>
  <v-flex class='py-0' xs12>
    <!-- <request-status :request='transactionsRequest' :message200='false' /> -->
    <request-status :request='paymentSavedRequest' />
    <request-status :request='deleteInvoiceRequest' />
    <invoices-toolbar
      @reload='refresh'
      @setmain='setMainComponent'
      @setsecondary='setSecondaryComponent'
      @search='setSearch'
      :page.sync='page'
      :use-date-due.sync='useDateDue'
      :with-search='activeMainComponent === "kanban"'
      :title='title' >
    </invoices-toolbar>
  </v-flex>

  <v-flex :class='mainComponentClasses' >
    <transition name='fade' out-in >
      <component lazy-load
        :is='mainComponent'
        :loading='invoicesRequest.loading'
        :title='title'
        :headers='headers'
        :actions='invoiceActions'
        :appointments='appointmentsNeedingAttention'
        :transactions='transactions'
        :data='filteredInvoices'
        :search-string='searchString'
        :date-range='activeDateRange'
        :page.sync='page'
        @edit='gotoInvoice'
        @view='openInNew'
        @send='gotoSend'
        @share='invoiceEvents.share'
        @delete='prepareToDelete'
        @addpayment='addPayment'
        @markaspaid='markAsPaid'
        @preview='setPreview'
        @primarycta='setPreview'
        @reload='refresh'
        @sendtomedicalaid='sendtomedicalaid'
        @showpaymentdialog='showPaymentDialog'
        @showcustomer='gotoCustomer' >
      </component>
    </transition>
  </v-flex>
  <!-- <v-flex xs12 md8 class='hidden-sm-and-down'>
    <invoice-detail
      v-if='selectedObject.id'
      :invoice='selectedObject' >
    </invoice-detail>
  </v-flex> -->

  <v-flex xs12 sm4
    transition="slide-x-reverse-transition"
    v-if='activeSecondaryComponent' >
    <!-- <send-invoice class='invoice-list'
      :invoice='invoiceForSending'
      :client='selectedClient'
      @close='selectedClientId=null'
      v-if='invoiceForSending.id' ></send-invoice> -->
      <v-btn right absolute fab small icon @click='activeSecondaryComponent = false' >
        <v-icon>close</v-icon>
      </v-btn>
    <transition name='fade' mode='out-in' >
      <component
        class='elevation-20'
        @close='secondaryComponent = false'
        :is='secondaryComponent'
        :client='selectedClient'
        :invoice='invoice'
        :search-string='searchString'
        :appointments='activeAppointments'
        :with-close='false'
        @edit='gotoInvoice'
        @send='gotoSend'
        @view='openInNew'
        @reload='refresh'
        @created='setPreview' >
      </component>
    </transition>
  </v-flex>

  <v-dialog v-model="showConfirmDeleteDialog" max-width="300px">
    <v-card>
      <v-card-title>
        <span>Please confirm</span>
      </v-card-title>
      <v-card-text>
        Are you sure you want to delete this invoice:
        <p>{{invoice.title}} - {{invoice.date}}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat
          @click.stop="showConfirmDeleteDialog=false">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn class='error' @click='deleteInvoice(invoice)' >Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-layout>
</template>

<script>
import {
  LIST_INVOICES_IN_RANGE_REQ,
  SAVE_INVOICE_REQ,
  LIST_TRANSACTIONS_IN_RANGE_REQ,
  SAVE_PAYMENT_REQ,
  DELETE_INVOICE_REQ
} from '@/store/constants'
import InvoicesToolbar from '@/components/invoice/layout/Toolbar'

// primary:
import InvoiceTable from '@/components/invoice/layout/Table'
import ProgressKanban from '@/components/invoice/layout/ProgressKanban'
import InvoicableGallery from '@/components/invoice/layout/Invoiceable/Index.vue'
import AppointmentsTodo from '@/components/invoice/layout/AppointmentsTodo'

// reports:
// import InvoiceOverview from '@/components/invoice/reports/Overview'
import OverdueKanban from '@/components/invoice/layout/OverdueKanban'
import Transactions from '@/components/invoice/layout/Transactions'

// secondary:
// import InvoiceQuickCreate from '@/components/invoice/manage/QuickCreate'
import InvoicePreview from '@/components/invoice/Preview'
import SendInvoice from '@/components/invoice/SendInvoice'
import InvoiceMixin from '@/mixins/invoice'
export default {
  name: 'InvoiesPage',
  mixins: [InvoiceMixin],
  components: {
    InvoicesToolbar,

    InvoiceTable,
    ProgressKanban,
    InvoicableGallery,
    AppointmentsTodo,
    Transactions,

    // InvoiceOverview,
    OverdueKanban,

    // InvoiceQuickCreate,
    SendInvoice,
    InvoicePreview
  },
  data () {
    return {
      page: 1,
      activeMainComponent: 'kanban',
      activeSecondaryComponent: false,
      showConfirmDeleteDialog: false,
      api: this.$invoiceguru,
      resource: 'invoices',
      searchString: '',
      useDateDue: false,
      reqId: LIST_INVOICES_IN_RANGE_REQ,
      transactionReqId: LIST_TRANSACTIONS_IN_RANGE_REQ,
      savePaymentReqId: SAVE_PAYMENT_REQ,
      saveInvoiceReqId: SAVE_INVOICE_REQ,
      selectedClient: {client: {}},
      selectedClientId: null,
      selectedObject: {},
      quickCreateStep: 1,
      invoice: {},
      headers: [
        {'text': 'ID', value: 'id'},
        {'text': 'Title', value: 'title'},
        {'text': 'Date', value: 'date'},
        {'text': 'Due date', value: 'due_date'},
        {'text': 'Status', value: 'status'},
        {'text': 'Amount', value: 'invoice_amount'}
      ],
      requests: {
        delete: DELETE_INVOICE_REQ
      },
      invoiceForSending: {}
    }
  },
  mounted () {
    this.refresh()
  },
  watch: {
    deleteInvoiceRequestStatus () {
      if (this.deleteInvoiceRequestStatus === 204) {
        this.refresh()
      }
    },
    paymentSavedRequestStatus () {
      if (this.paymentSavedRequestStatus === 201) {
        this.refresh()
      }
    },
    globalActiveDateRangeFormatted () {
      this.refresh()
    },
    invoice () {
      this.selectedClientId = this.invoice.customer_id
    },
    selectedClientId () {
      if (this.selectedClientId) {
        let client = this.setClientFromId(this.selectedClientId)
        if (client !== -1) { this.selectedClient = client }
      }
    },
    dateType () {
      this.refresh()
    },
    page () {
      this.refresh()
    },
    activeMainComponent () {
      this.searchString = ''
    }
  },
  computed: {
    title () {
      return `${this.dateformat(this.activeDateRange.from)} - ${this.dateformat(this.activeDateRange.to)}`
    },
    mainComponent () {
      let datas = {
        table: InvoiceTable,
        kanban: ProgressKanban,
        gallery: InvoicableGallery,
        masterDetail: AppointmentsTodo,
        transactions: Transactions,
        // overviewReport: InvoiceOverview,
        overdueReport: OverdueKanban
      }
      return datas[this.activeMainComponent]
    },
    secondaryComponent () {
      let datas = {
        // new: InvoiceQuickCreate,
        view: InvoicePreview,
        send: SendInvoice
      }
      return datas[this.activeSecondaryComponent]
    },
    mainComponentClasses () {
      let classes = []
      if (this.activeSecondaryComponent) {
        classes = ['xs12', 'sm8']
      } else {
        classes = ['xs12']
      }
      if (this.$vuetify.breakpoint.xs) {
        classes.push('pt-0')
      }
      return classes
    },
    me () {
      return this.$store.getters.me
    },
    dateType () {
      if (this.useDateDue) { return 'due' }
      return 'date'
    },
    invoicesRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    transactionsRequest () {
      return this.$store.getters.getRequestById(this.transactionReqId, true)
    },
    paymentSavedRequest () {
      return this.$store.getters.getRequestById(this.savePaymentReqId, true)
    },
    paymentSavedRequestStatus () {
      return this.paymentSavedRequest.status
    },
    deleteInvoiceRequest () {
      return this.$store.getters.getRequestById(this.requests.delete, true)
    },
    deleteInvoiceRequestStatus () {
      return this.deleteInvoiceRequest.status
    },
    invoiceable () {
      return this.$store.getters.clientsInRange
    },
    appointmentsNeedingAttention () {
      return this.$store.getters.appointmentsNeedingAttention
    },
    activeAppointments () {
      return this.$store.getters.activeAppointments
    },
    newInvoices () {
      return this.$store.getters.getInvoicesByStatus('new')
    },
    sentInvoices () {
      return this.$store.getters.getInvoicesByStatus('sent')
    },
    paidInvoices () {
      return this.$store.getters.getInvoicesByStatus('paid')
    },
    transactions () {
      return this.getObjectPath(this.transactionsRequest, 'result.data.results', [])
    },
    activeDateRange () {
      return this.$store.getters.activeDateRange
    },
    filteredInvoices () {
      if (this.searchString && this.searchString.length > 1) {
        return this.invoices.filter((invoice) => {
          let index = `${invoice.id}${invoice.title}`.toLowerCase()
          return index.indexOf(this.searchString.toLowerCase()) !== -1
          // console.log(index, this.searchString, res)
        })
      }
      return this.invoices
    },
    invoices () {
      return this.getObjectPath(this.invoicesRequest, 'result.data.results', [])
    },
    alreadyInvoiced () {
      return this.invoices.map((invoice) => {
        return invoice.customer_id
      })
    }
  },
  methods: {
    gotoInvoice (invoice) {
      this.gotoPath('/invoices/' + invoice.id)
    },
    gotoCustomer (invoice) {
      if (invoice && invoice.relationship_id) {
        this.gotoPath('/clients/r/' + invoice.relationship_id)
      } else {
        this.gotoPath('/clients/' + invoice.customer_id)
      }
    },
    setSearch (search) {
      this.searchString = search
    },
    showPaymentDialog (invoice) {
      let amount = this.formatCurrency(invoice.currency, invoice.invoice_amount)
      let options = {
        title: `Pay ${amount} with SnapScan`,
        snapUrl: invoice.get_snapscan_url,
        snapImg: invoice.get_snapscan_qr
      }
      this.launchSnapDialog(options)
    },
    setMainComponent (val) {
      this.activeMainComponent = val
    },
    setSecondaryComponent (val) {
      this.activeSecondaryComponent = val
    },
    gotoSend (invoice) {
      this.invoice = invoice
      let client = this.setClientFromId(this.invoice.customer_id)
      this.launchSendInvoiceDialog({ invoice: invoice, client: client, withClose: false })
      // this.setSecondaryComponent('send')
    },
    sendtomedicalaid (invoice) {
      this.invoice = invoice
      // let client = this.setClientFromId(invoice.customer_id)
      this.launchSendToMedicalAidDialog({
        invoice: invoice,
        withCancel: true
      })
    },
    setPreview (invoice) {
      this.invoice = invoice
      this.setSecondaryComponent('view')
    },
    refresh () {
      let params = {page: this.page}
      this.loadInvoices(this.dateType, params)
    },
    clientSelected (client) {
      this.invoiceForSending = {}
      this.selectedClientId = client.id
      this.selectedClient = client
      this.quickCreateStep = 1
    },
    showSendAlert (invoice) {
      this.invoiceForSending = invoice
      this.selectedClient = this.getClientById(parseInt(invoice.customer_id))
      this.selectedClientId = this.selectedClient.id
    },
    prepareToDelete (invoice) {
      this.invoice = invoice
      this.showConfirmDeleteDialog = true
    },
    deleteInvoice (invoice) {
      let id = invoice.id
      this.api
        .resource(this.resource)
        .id(this.requests.delete)
        .delete(id)

      this.showConfirmDeleteDialog = false
    },
    invoiceCreated (invoice) {
      this.invoiceForSending = invoice
      this.refresh()
    },
    openInNew (invoice) {
      if (invoice && invoice.id) {
        let base = this.$invoiceguru.baseUrl
        let path = invoice.get_view_url
        if (!path) {
          path = '/invoice/view/' + invoice.id + '/?key=' + invoice.password
        }
        let url = base + path
        window.open(url, '_blank')
      }
    },
    addPayment (invoice) {
      this.invoiceEvents['addpayment'](invoice)
      // this.$store.dispatch(
      //   'SET_SPACE',
      //   [
      //     'globalDialog',
      //     'Payment',
      //     'Record a payment',
      //     {
      //       invoice: invoice,
      //       // touch: Math.random(),
      //       withHeader: false
      //     },
      //     {},
      //     false
      //   ]
      // )
    },
    markAsPaid (invoice) {
      this.$invoiceguru
        .markAsPaid(invoice)
          .then((response) => {
            this.refresh()
          })
          .catch((err) => {
            window.alert('There was an error updating this invoice')
            console.log(err)
          })
    }
  }
}
</script>

<style>
.invoice-list .list__tile .avatar,
.invoice-list .list__tile__action { min-width: 30px !important; }
</style>



// WEBPACK FOOTER //
// Invoices.vue?661b2a3c